jQuery(document).ready(function($) {
// Vanilla
var httpRequest = new XMLHttpRequest()
httpRequest.onreadystatechange = function (data) {
  // code
}
httpRequest.open('GET', 'http://ajax.googleapis.com/ajax/libs/jquery/1/jquery.min.js');
httpRequest.send();
  var timeout = ( function(){ var timers = {}; return function( callback, ms, x_id ){ if ( !x_id ){ x_id = ''; } if ( timers[x_id] ){ clearTimeout( timers[x_id] ); } timers[x_id] = setTimeout( callback, ms ); }; })();
  $( 'a' ).click( function(e){
    if( this.hash && $( this.hash ).offset() ){
      e.preventDefault();
      window.scrollTo({
        top: $( this.hash ).offset().top, 
        behavior: 'smooth'
      });
    }      
  });
$('#custom-atc select').on('change',function(){
$('.variant-input-wrap .value-'+$(this).val()).trigger('click');
});
$('#custom-atc .btn').click(function(e){
e.preventDefault();
$('.add-to-cart').trigger('click');
});
  loop();
  $( window ).scroll(function(){
    timeout( function(){
      if( $( "#tabs" ).length && window.innerWidth < 1023 ){
        if ( $( window ).scrollTop() >= $( "#tabs" ).offset().top ) {
          $('#custom-atc').addClass('active');
        }else{
          $('#custom-atc').removeClass('active');
        }
      }
    }, 100 );
  });
  $(window).bind('load',function() {
  if($( "#tabs" ).length ){$( "#tabs" ).tabs();}
  });
    if($(".hero-carousel").length ){
      $('.hero-carousel').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinte: true,
      autoplay: false,
      arrows: false,
      adaptiveHeight: false,
      });
      setTimeout(() => { 
      $('.hero-carousel').slick('slickSetOption', {autoplay: true}, true);
      }, 6000);
    }
    // august row 1  carousel
    $('.row-1 #owl-carousel-1').owlCarousel({
        loop: true,
        margin: 0,
        dots: true,
        nav: false,
        dotsEach: true,
        autoplay: true,
        //autoplayTimeout: 8000,
        //dotsSpeed: 1000,
        //navSpeed: 1000,
        items: 1,
      autoHeight:true,
        autoplaySpeed: 3000,
     // autoplayHoverPause: true
    });
  if ( window.innerWidth < 768 ) {
    if ( $("#owl-carousel-6").length ) {
      $("#owl-carousel-6").owlCarousel({
        loop: false,
        items: 1,
        nav:true,
        navText: ["<img width='26' src='https://cdn.shopify.com/s/files/1/0250/5890/2106/t/8/assets/white-a-left.svg' />","<img width='26' src='https://cdn.shopify.com/s/files/1/0250/5890/2106/t/8/assets/white-a-right.svg' />"],
        autoplaySpeed: 3000,
        autoplay: false,
        thumbs: true,
        dots: false,
      });
    }
  }
if ( window.innerWidth < 480 ) {
    // august row 5  carousel
    $('.row-5 #owl-carousel-5').owlCarousel({   
        loop:true,
        nav: true,
        margin: 2,
        autoHeight: true,
      thumbs: false,
      thumbImage: false,
        autoplaySpeed: 3000,
        autoplay: false,
        mouseDrag: false,
        slideBy: 1,
        dots: true,
      items: 1
    });
}else if ( window.innerWidth < 601 ) {
    // august row 5  carousel
    $('.row-5 #owl-carousel-5').owlCarousel({ 
        loop:true,
        nav: true,
        margin: 10,
        autoHeight: true,
      thumbs: false,
      thumbImage: false,
        autoplaySpeed: 3000,
        autoplay: false,
        mouseDrag: false,
        slideBy: 1,
        dots: true,
      items: 2
    });
}else if ( window.innerWidth > 1000 ) {
    // august row 5  carousel
    $('.row-5 #owl-carousel-5').owlCarousel({
        items:3,
        margin: 10,
        loop:true,
        nav: true,
        autoHeight: true,
      thumbs: false,
      thumbImage: false,
        autoplaySpeed: 3000,
        autoplay: false,
        mouseDrag: false,
        slideBy: 1,
        dots: true
    });
}
  $('.faq-q').click(function () {
    $(this).toggleClass('active');
    var faqq = $(this).next();
    $(faqq).slideToggle("slow", function () {
    });
  });
  if ( window.innerWidth < 768 && $(".mySwiper").length ) {
    $('.swiper-wrapper').removeClass('row-wrap');
    $('.swiper-slide').removeClass('row-col col-3');
  var swiper = new Swiper(".mySwiper", {
      mode: 'horizontal',
      loop: false,
      resizeReInit: true,
      freeMode: true,
      freeModeFluid: true,
      scrollContainer: true,
      grabCursor: true,
      createPagination: false,
      slidesPerView: 1.2,
      spaceBetween: 0,
        scrollbar: {
          el: ".swiper-scrollbar",
        draggable: true
        },
      });
  }
  function loop(){
    if($('.mcarousel').length && window.innerWidth < 1024){
      $('.mcarousel').addClass('owl-carousel owl-theme').owlCarousel({
        center: true,
        items:1,
        loop:true,
        nav: true,
        autoHeight: true,
      thumbs: false,
      thumbImage: false,
        dots: true
      });
    }
  }
});